/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("CurrentTitleVMBehavior", ["BehaviorBase"], function (context, cls) {
  /**
   * @class CurrentTitleVMBehavior
   * @memberOf classes
   * @extends classes.BehaviorBase
   */
  cls.CurrentTitleVMBehavior = context.oo.Singleton(cls.BehaviorBase, function ($super) {
    return /** @lends classes.CurrentTitleVMBehavior.prototype */ {
      __name: "CurrentTitleVMBehavior",

      // Execute behavior when name,text or image attributes on window or userinterface change.
      // Additionally, execute this behavior when attribute 'currentWindow' of the userinterface changes.
      watchedAttributes: {
        anchor: ["name", "text", "image", "currentWindow"]
      },

      /**
       * Switches the current window
       */
      _apply: function (controller, data) {
        const anchorNode = controller.getAnchorNode(),
          app = anchorNode.getApplication(),
          session = app.getSession();
        if (app !== session.getCurrentApplication()) {
          return;
        }
        const uiNode = app.getNode(0);
        const uiTitle = uiNode.attributeByVM("text") || uiNode.attributeByVM("name");
        const uiImage = uiNode.resource("image", true);
        const currentWindow = uiNode.getFirstChildWithId(uiNode.attribute("currentWindow"));
        const windowNode = (anchorNode.getTag() === "Window" ? anchorNode : anchorNode.getAncestor("Window")) || currentWindow;
        if (!windowNode) {
          const userInterfaceWidget = uiNode.getController().getWidget();
          if (userInterfaceWidget.setText) {
            userInterfaceWidget.setText(uiTitle);
          }
          if (userInterfaceWidget.setImage) {
            userInterfaceWidget.setImage(uiImage);
          }
          return;
        }

        const formNode = windowNode.getFirstChild("Form");

        // Return to simplicity
        const title = windowNode.attributeByVM("text") || windowNode.attributeByVM("name");

        const image = formNode?.resource("image", true) || windowNode?.resource("image", true) || uiImage;

        windowNode.setTitle(title);
        const windowWidget = windowNode.getController().getWidget();
        if (title && windowWidget.setText) {
          windowWidget.setText(title);
        }

        if (!windowNode.isModal()) {
          // update title in window list only if it's current window
          if (windowNode === currentWindow) {
            context.WindowListService.setCurrentTitle(title);
          }
        }
      }
    };
  });
});
